import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'shipment-details',
  templateUrl: './shipment-details.component.html',
  styleUrls: ['./shipment-details.component.scss']
})
export class ShipmentDetailsComponent implements OnInit {

  @Input() shipmentDetails: any;
  screenSize = window.innerWidth;
  constructor() { }

  ngOnInit(): void {
  }

}
